import { ActionCreator, Dispatch } from "redux";
import { ThunkAction } from "redux-thunk";

import { ApplicationState } from "../store/ApplicationState";
import { TabSessionDataDispatchTypes } from "../models/DispatchTypes/TabSessionStorage";
import { TabSessionStorageDispatchTypes } from "../constants/TabSessionStorage";
import { TabData } from "../models/TabSessionStorage";

export const saveTabSessionStorageResp: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    TabSessionDataDispatchTypes
  >
> = (SessionData: TabData) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: TabSessionStorageDispatchTypes.SET_TAB_DATA_INVOKE,
    });
    const response = { SessionData };
    sessionStorage.setItem("ReferralRequest", JSON.stringify(SessionData));
    dispatch({
      response,
      type: TabSessionStorageDispatchTypes.SET_TAB_DATA_SUCCESS,
    });
  };
};
